import { useState, useEffect } from "react";
import { GetDealerships } from "../../helpers/api";
import Container from "react-bootstrap/Container";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

function SuperAdmin() {
  const [dealershipList, setDealershipList] = useState([]);
  const [requestSent, setRequestSent] = useState(false);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (!requestSent) {
      setLoader(true);
      getDealershipList();
    }
  }, [requestSent]);

  const getDealershipList = async () => {
    try {
      const list = await GetDealerships();
      setLoader(false);
      setRequestSent(true);
      setDealershipList(list);
    } catch (error) {
      setLoader(false);
      toast.error(error.toString(), {
        position: "top-center",
        autoClose: 3000,
        closeOnClick: true,
        pauseOnHover: true,
      });
    }
  };
  const refreshList = () => {
    setLoader(true);
    getDealershipList();
  };
  return (
    <Container>
      <div className={"overlay-loader " + (loader ? "d-block" : "d-none")}>
        <Loader
          className="loader-item"
          type="ThreeDots"
          color="#E52D27"
          height={100}
          width={100}
        />
      </div>
      <ToastContainer />
      <table className="table table-striped">
        <thead>
          <tr>
            <th scope="col">
              <i className="fas fa-th-list"></i>
            </th>
            <th scope="col">Code</th>
            <th scope="col">Name</th>
            <th scope="col">Login</th>
            <th>
              <div className="float-end">
                <div className="d-inline-block m-1">
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={refreshList}
                  >
                    <i className="fas fa-sync-alt"></i> Refresh List
                  </button>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {dealershipList.length > 0
            ? dealershipList.map((dealership, i) => (
                <tr key={i}>
                  <th scope="row">
                    <span className="me-4">{i + 1}</span>
                  </th>
                  <td>{dealership.dealershipCode}</td>
                  <td>{dealership.dealershipName}</td>
                  <td>{dealership.email}</td>
                  <td>
                    <div className="float-end">
                      <div className="d-inline-block m-1">
                        <a
                          className="btn btn-sm btn-secondary"
                          href={dealership.dvrLink}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="fas fa-list"></i> DVR
                        </a>
                      </div>
                    </div>
                  </td>
                </tr>
              ))
            : ""}
        </tbody>
      </table>
    </Container>
  );
}

export default SuperAdmin;
